module.exports = __webpack_public_path__ + "5266e3d2effabe103a313ee6ff7828c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/L3930R.jpg
// module id = 689
// module chunks = 0